import React, {useState} from "react";

export const StringInput = ({property}) => {
    const [, forceUpdate] = useState();
    return (
        <input
            className="string-input"
            type="text"
            value={property.get() ?? ''}
            onChange={e => {
                forceUpdate(property.set(e.target.value));
                APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
            }}
        />
    );
}

